import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaGem, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from '../../components/DynamicListingPage';
import { useQuery, useMutation } from "@tanstack/react-query";
import { getStoneDetails } from "../../helpers/http_stones_requests";
import { useParams } from "react-router-dom";
import { getStoneVariations, deleteStoneVariation } from "../../helpers/http_stone_variations_requests";
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';

export default function StoneVariations() {

    const { verifyPermission } = usePermissions();
    const { id: user_id } = useAuth();

    const { id } = useParams();

    const stoneDetailsQuery = useQuery({ queryKey: ['getStoneDetails', id], queryFn: () => getStoneDetails(id), staleTime: 1000 * 5 });

    const { data: response } = stoneDetailsQuery?.data?.data ?? {};

    const { data, isFetching, refetch } = useQuery({ queryKey: ['getStoneVariations', id], queryFn: () => getStoneVariations(id), staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const deleteMutation = useMutation({
        mutationFn: (variationId) => deleteStoneVariation(variationId, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (variationId) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar esta variação de pedra?', () => {
            deleteMutation.mutate(variationId);
        });
    };

    const componentName = 'products';

    const columns = [
        {
            field: 'name',
            headerName: 'Nome',
        },
        {
            field: 'description',
            headerName: 'Descrição',
        },
        {
            field: 'size',
            headerName: 'Tamanho',
        },
        {
            field: 'price',
            headerName: 'Preço',
        },
        {
            field: 'actions',
            headerName: 'Ações',
            type: 'number',
        },
    ];

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/pedra-variacao-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/pedra-variacao-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return <ListingPage canAddData={verifyPermission(componentName, 3)} isLoading={isFetching} icon={FaGem} pageTitle={`${response?.name || ''} - Variações`} addButtonTitle={"variação"} addPath={"/pedra-variacao-cadastrar/" + id} columns={columns} data={dataList} actions={renderActions} />
};